import createIcon from '../../createIcon';

/**
 * @component @name ThumbUpOffAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMTEgNi43MkwxMi41NCA5LjYxQzEyLjQyIDEwLjIgMTIuNTggMTAuODEgMTIuOTYgMTEuMjdDMTMuMzQgMTEuNzMgMTMuOSAxMiAxNC41IDEySDIwVjEzLjA4TDE3LjQzIDE5SDkuMzRDOS4xNiAxOSA5IDE4Ljg0IDkgMTguNjZWMTAuODJMMTMuMTEgNi43MlpNMTQgM0w3LjU5IDkuNDFDNy4yMSA5Ljc5IDcgMTAuMyA3IDEwLjgzVjE4LjY2QzcgMTkuOTUgOC4wNSAyMSA5LjM0IDIxSDE3LjQ0QzE4LjE1IDIxIDE4LjggMjAuNjMgMTkuMTYgMjAuMDNMMjEuODMgMTMuODhDMjEuOTQgMTMuNjMgMjIgMTMuMzYgMjIgMTMuMDhWMTJDMjIgMTAuOSAyMS4xIDEwIDIwIDEwSDE0LjVMMTUuNDIgNS4zNUMxNS40NyA1LjEzIDE1LjQ0IDQuODkgMTUuMzQgNC42OUMxNS4xMSA0LjI0IDE0LjgyIDMuODMgMTQuNDYgMy40N0wxNCAzWk00IDEwSDJWMjFINEM0LjU1IDIxIDUgMjAuNTUgNSAyMFYxMUM1IDEwLjQ1IDQuNTUgMTAgNCAxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbUpOffAlt = createIcon('ThumbUpOffAlt', [
  [
    'path',
    {
      d: 'M13.11 6.72L12.54 9.61C12.42 10.2 12.58 10.81 12.96 11.27C13.34 11.73 13.9 12 14.5 12H20V13.08L17.43 19H9.34C9.16 19 9 18.84 9 18.66V10.82L13.11 6.72ZM14 3L7.59 9.41C7.21 9.79 7 10.3 7 10.83V18.66C7 19.95 8.05 21 9.34 21H17.44C18.15 21 18.8 20.63 19.16 20.03L21.83 13.88C21.94 13.63 22 13.36 22 13.08V12C22 10.9 21.1 10 20 10H14.5L15.42 5.35C15.47 5.13 15.44 4.89 15.34 4.69C15.11 4.24 14.82 3.83 14.46 3.47L14 3ZM4 10H2V21H4C4.55 21 5 20.55 5 20V11C5 10.45 4.55 10 4 10Z',
      key: '1npe46',
    },
  ],
]);

export default ThumbUpOffAlt;
